/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import * as _ from 'lodash'
import {
  ENABLE_MIN_BET_RATE,
  getClubSpcialBetMaxMoney,
  Mining,
} from '@game/util'
import {
  formatNumber,
  getPropertyIdByBetSlipIndexKey,
  getRatioTicketMoney,
  getSingleBetPenaltyRate,
  getTextByPropertyId,
  getTicketCountFromTicket,
  getTicketFromTicketCount,
  isAvailableGotBlessItemFoldCondition,
  isExtraOddsItemSupportBetMoneyType,
  isLsportsEnv,
  makeGodBlessItemAvailableFoldConditionInvalidDialogText,
  makeMaxBetAlertText,
  maxTicketBetMoney,
  showToast,
  TOAST_TYPE,
} from '@utils/utils'
import { BET_TICKET_TYPE } from '@constants/index'
import { CartItem } from '@store/matchupStore'
import { authStore, globalStore, matchupStore, componentStore } from '@store/index'
import { LS_OUTCOME_TYPE, OUTCOME_TYPE } from '@constants/market'
import { GAME_TYPE } from '@game-type/game-market-types'
import { BET_TYPE_ON, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import { NumberFormatValues } from 'react-number-format'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
// import { GlobalStoreKey } from '@v2/constants/common'
// image
// import checkIco from '@assets/images/icon/matchup_icon/check_icon.png'
import { TrashIco } from '@shared/Icon/EtcIcon'
// css
import { Button } from '@styles/button.style'
import { BubbleTextType, BubbleType } from '@store/globalStore'
import { ComponentCartItem } from '@store/componentStore'
import * as MatchUtils from '@v2/utils/match-utils'
import { BetSlipHelperListWrap } from './index.style'
import LiveTagIco from '@shared/Icon/MatchupIcon/LiveTagIco'
import { ProducerType } from '@game-type/betradar-type'
import DialogUtils from '@utils/dialog-utils'
import classNames from 'classnames'
import ICON_LOCK from '@assets/images/icon/lock.png'

// icon
// const CheckboxInnerImg = <img src={checkIco} alt="체크 표시" css={[CheckboxImg, HelperCheckBoxImgStyle]}/>

type onEventFunc = (e: string) => void

function fieldTypeToString(type: string) {
  let str = ''
  if (isLsportsEnv()) {
    switch (type) {
      case LS_OUTCOME_TYPE.TOTAL_UNDER:
        str = '언더'
        break
      case LS_OUTCOME_TYPE.TOTAL_OVER:
        str = '오버'
        break
    }
  } else {
    switch (type) {
      case OUTCOME_TYPE.TOTAL_UNDER:
        str = '언더'
        break
      case OUTCOME_TYPE.TOTAL_OVER:
        str = '오버'
        break
    }
  }
  return str
}

export function makeFoldWay(item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string) {
  const onClickDeleteFoldItem = () => onEventFunc(item.cartId)
  const { selectedOutcome } = item
  let selection = item.selection
  if (isLsportsEnv()) {
    selection = item.outcomeMetaId
  }
  
  const isLiveMarket = item.producerId === ProducerType.LIVEODDS
  return (
    <div className={`bet-list-info ${arrowClassName}`}>
      <ul>
        <li className="select-info">
          {isLiveMarket && (<LiveTagIco/>)}
          <span className="select-team">{fieldTypeToString(selection) || selectedOutcome.name}</span>
          <span className="rate">
            <span className="change-rate-arrow"/>
            {item.rate.toFixed(2)}
          </span>
        </li>
        <li className="market-item">
          <span className="market-name">
            {item.marketName}
          </span>
        </li>
        <li className="team-info">
          <span className="team-detail-info">
            {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[item.sportId] : SPORT_ID_ICON_MAP[item.sportId]}
            <span className="team-name">
              (홈) {item.match.homeTeamName} vs {item.match.awayTeamName}
            </span>
          </span>
        </li>
      </ul>
      {onEventFunc && <Button className="delete-select" onClick={onClickDeleteFoldItem}><TrashIco/></Button>}
    </div>
  )
}

// 핸디캡
export function makeFoldHandicap(item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string) {
  const { specifiers = {}, selectedOutcome } = item
  const { hcp } = specifiers
  const onClickDeleteFoldItem = () => onEventFunc(item.cartId)
  let selection = item.selection
  if (isLsportsEnv()) {
    selection = item.outcomeMetaId
  }
  const isLiveMarket = item.producerId === ProducerType.LIVEODDS
  return (
    <div className={`bet-list-info ${arrowClassName}`}>
      <ul>
        <li className="select-info">
          {isLiveMarket && (<LiveTagIco/>)}
          <span className="select-team">{fieldTypeToString(selection) || selectedOutcome.name}</span>
          <span className="rate">
            <span className="change-rate-arrow"/>
            {item.rate.toFixed(2)}
          </span>
        </li>
        <li className="market-item">
          <span className="market-name">
            {item.marketName}
          </span>
          <span className="bet-point">
            &nbsp;{hcp || ''}
          </span>
        </li>
        <li className="team-info">
          <span className="team-detail-info">
            {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[item.sportId] : SPORT_ID_ICON_MAP[item.sportId]}
            <span className="team-name">
              (홈) {item.match.homeTeamName} vs {item.match.awayTeamName}
            </span>
          </span>
        </li>
      </ul>
      {onEventFunc && <Button className="delete-select" onClick={onClickDeleteFoldItem}><TrashIco/></Button>}
    </div>
  )
}

// 언더 오버
export function makeFoldUnderOver(
  item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string
) {
  const { specifiers = {} } = item
  const { total } = specifiers
  const onClickDeleteFoldItem = () => onEventFunc(item.cartId)
  let selection = item.selection
  if (isLsportsEnv()) {
    selection = item.outcomeMetaId
  }
  const isLiveMarket = item.producerId === ProducerType.LIVEODDS
  return (
    <div className={`bet-list-info ${arrowClassName}`}>
      <ul>
        <li className="select-info">
          {isLiveMarket && (<LiveTagIco/>)}
          <span className="select-team">{fieldTypeToString(selection)}</span>
          <span className="rate">
            <span className="change-rate-arrow"/>
            {item.rate.toFixed(2)}
          </span>
        </li>
        <li className="market-item">
          <span className="market-name">
            {item.marketName}
          </span>
          <span className="bet-point">
            &nbsp;{total || ''}
          </span>
        </li>
        <li className="team-info">
          <span className="team-detail-info">
            {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[item.sportId] : SPORT_ID_ICON_MAP[item.sportId]}
            <span className="team-name">
              (홈) {item.match.homeTeamName} vs {item.match.awayTeamName}
            </span>
          </span>
        </li>
      </ul>
      {onEventFunc && <Button className="delete-select" onClick={onClickDeleteFoldItem}><TrashIco/></Button>}
    </div>
  )
}

export function makeFoldIrregular(
  item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string
) {
  const { specifiers = {}, selectedOutcome } = item
  const { total, hcp } = specifiers
  const onClickDeleteFoldItem = () => onEventFunc(item.cartId)
  let selection = item.selection
  if (isLsportsEnv()) {
    selection = item.outcomeMetaId
  }
  const isLiveMarket = item.producerId === ProducerType.LIVEODDS
  return (
    <div className={`bet-list-info ${arrowClassName}`}>
      <ul>
        <li className="select-info">
          {isLiveMarket && (<LiveTagIco/>)}
          <span className="select-team">{fieldTypeToString(selection) || selectedOutcome.name}</span>
          <span className="rate">
            <span className="change-rate-arrow"/>
            {item.rate.toFixed(2)}
          </span>
        </li>
        <li className="market-item">
          <span className="market-name">
            {item.marketName}
          </span>
          <span className="bet-point">
            &nbsp;{total || hcp || ''}
          </span>
        </li>
        <li className="team-info">
          <span className="team-detail-info">
            {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[item.sportId] : SPORT_ID_ICON_MAP[item.sportId]}
            <span className="team-name">
              (홈) {item.match.homeTeamName} vs {item.match.awayTeamName}
            </span>
          </span>
        </li>
      </ul>
      {onEventFunc && <Button className="delete-select" onClick={onClickDeleteFoldItem}><TrashIco/></Button>}
    </div>
  )
}

export function makeFoldSpecial(item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string) {
  // const { cartId, checked, sportId, specifiers = {}, marketType, rate, selection } = item
  // const { total } = specifiers
  //
  // const meta = SPECIAL_META[sportId.toString()]
  // const metaOdds = meta.odds[marketType]
  // const oddsName = metaOdds.name
  // const leftOddsName = metaOdds.oddsField['1'].name
  // const rightOddsName = metaOdds.oddsField['2'].name
  // const selectionName = selection === '1' ? leftOddsName : rightOddsName
  // let eleSpecifiers
  // if (total) {
  //   eleSpecifiers = <BetPoint>{total}</BetPoint>
  // }
  // const onChangeSpecialFoldCheckbox = () => onCheckedChange(cartId)
  // const onClickSpecialFoldLabel = () => onCheckedChange(cartId)
  // return (
  //   <div className="cursor-pointer">
  //     test22222222222222222
  //     {/*<input type="checkbox" id={cartId} checked={checked} css={Checkbox} onChange={onChangeSpecialFoldCheckbox}/>*/}
  //     {/*<label htmlFor={cartId} css={HelperCheckboxStyle}>*/}
  //     {/*  {CheckboxInnerImg}*/}
  //     {/*</label>*/}
  //     {/*<LabelWrap onClick={onClickSpecialFoldLabel}>*/}
  //     {/*  <SlipWrap>*/}
  //     {/*    <PickTxt>{selectionName}</PickTxt>*/}
  //     {/*    <Rate className="rate">{rate.toFixed(2)}</Rate>*/}
  //     {/*  </SlipWrap>*/}
  //
  //     {/*  <SlipWrap>*/}
  //     {/*    <TypeTxt>[{oddsName}]</TypeTxt>*/}
  //     {/*    {eleSpecifiers}*/}
  //     {/*  </SlipWrap>*/}
  //     {/*</LabelWrap>*/}
  //   </div>
  // )

  return (<div>test</div>)
}

function makeEmpty(item: CartItem | ComponentCartItem, onEventFunc: onEventFunc, arrowClassName: string) {
  return <Fragment/>
}

export function makeFoldItems(items: CartItem[] | ComponentCartItem[], onEventFunc: onEventFunc) {
  const foldItems = []
  for (const el of items) {
    if (!el) {
      continue
    }
    let className = ''
    const { changeRate = { from: null, to: null } } = el
    const { from, to } = changeRate

    if (from && to) {
      if (from.rate < to.rate) {
        className = 'up'
      } else {
        className = 'down'
      }
    }

    let func = makeEmpty
    if (el.isSpecial) {
      func = makeFoldSpecial
    } else if (Mining.isRegularOutcomeWay(el.marketType) === true) {
      func = makeFoldWay
    } else if (Mining.isRegularOutcomeHandicap(el.marketType) === true) {
      func = makeFoldHandicap
    } else if (Mining.isRegularOutcomeUnderOver(el.marketType) === true) {
      func = makeFoldUnderOver
    } else {
      func = makeFoldIrregular
    }

    const isLock = el?.isLocked || false
    const betSlipHelperListWrapClass = classNames(className, {
      lock: isLock,
    })

    // NOTE: 실질적인 up,down 컨트롤은 betSlipHelperKey로 조절한다
    const betSlipHelperKey = `BetSlipHelper:BetSlipHelperListWrap:${el.cartId}`
    foldItems.push(
      <BetSlipHelperListWrap key={betSlipHelperKey} className={betSlipHelperListWrapClass}>
        {/*<BetSlipHelperList className={className}>*/}
        {func(el, onEventFunc, className)}
        {/*{CheckboxInnerImg}*/}
        {/*</BetSlipHelperList>*/}
        {isLock && <img src={ICON_LOCK} alt="배팅 잠금" className="lock-icon"/>}
      </BetSlipHelperListWrap>,
    )
  }
  return foldItems
}

export function isInputNotAvailable(cart: CartItem[]) {
  return _.size(cart) <= 0
}

export function isExceedMaxBetMoney(betMoney: number, maxBetMoney = globalStore.getClubGmoneyMaxBetLimit()) {
  // 최대 베팅 금액이 무제한인 경우
  if (maxBetMoney < 0) {
    return false
  }

  return betMoney > maxBetMoney
}

// NOTE: 최소(1만베팅권) 기준으로 베팅권 사용가능한지
export function isBetTicketInputNotAvailable(userTicketCount: number) {
  const ticketCount = getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, userTicketCount)
  return ticketCount <= 0
}

function isMinRateValidate(rate: number) {
  return rate >= ENABLE_MIN_BET_RATE
}

export function setUserInputBetMoney(
  values: NumberFormatValues, money: number, updater: number, setUpdater: React.Dispatch<React.SetStateAction<number>>,
): void {
  const selectedBetSlipTabIndexKey = matchupStore.selectedBetSlipTabIndexKey
  const propertyId = getPropertyIdByBetSlipIndexKey(selectedBetSlipTabIndexKey)

  const { value } = values
  const asNumber = Number(value)
  if (asNumber > money && money > 0) {
    matchupStore.setBetMoney(money, propertyId)
    setUpdater(updater + 1)
  } else {
    matchupStore.setBetMoney(asNumber, propertyId)
    setUpdater(updater + 1)
  }
}

export function doBet(
  cart: CartItem[], categoryTab: number, sportTab: number, moneyInputSelector: string, rate: number
): void {
  if (isInputNotAvailable(cart)) {
    return
  }

  if (!isMinRateValidate(rate)) {
    DialogUtils.showMinRateValidate()
    return
  }

  if (isExtraOddsItemSupportBetMoneyType(matchupStore.betMoneyType)
    && !_.isEmpty(componentStore.selectedUserExtraOddsItem)
    && !isAvailableGotBlessItemFoldCondition(cart)) {
    globalStore.showBubblePopupTimer(
      BubbleTextType.DEFAULT_ALERT,
      `신의 가호는 ${_.join(makeGodBlessItemAvailableFoldConditionInvalidDialogText(), ' ')}`,
      BubbleType.BET_SLIP,
    )
    return
  }

  const moneyInputElem: HTMLInputElement = document.querySelector(`${moneyInputSelector}`)
  if (moneyInputElem) {
    moneyInputElem.blur()
  }

  const matchIds = []
  for (const item of cart) {
    matchIds.push(item.matchId)
  }

  matchupStore.bet()
}

export function onClickMoneyButton(
  value: number,
  targetCart: CartItem[],
  targetBetMoney: number,
  betMoneyType: PROPERTY_ID,
  money: number,
  maxBetMoney: number
): void {
  if (isInputNotAvailable(targetCart)) {
    return
  }

  const plusNumber = value ? Number(value) : 0
  if (money < targetBetMoney + plusNumber) {
    showToast(TOAST_TYPE.INFO, `보유한 ${getTextByPropertyId(betMoneyType)}가 부족합니다.`)
    return
  }

  if (isExceedMaxBetMoney(targetBetMoney + plusNumber, maxBetMoney)) {
    if (targetBetMoney >= maxBetMoney) {
      const maxBetAlertText = makeMaxBetAlertText(betMoneyType, maxBetMoney)
      globalStore.showBubblePopupTimer(BubbleTextType.MAX_BET_ALERT, maxBetAlertText, BubbleType.BET_SLIP)
    }
    matchupStore.setBetMoney(maxBetMoney, betMoneyType)
    return
  }

  const addBetMoney = (reset = false) => {
    if (money < (reset ? 0 : targetBetMoney) + plusNumber) {
      showToast(TOAST_TYPE.INFO, `보유한 ${getTextByPropertyId(betMoneyType)}가 부족합니다.`)
    } else {
      matchupStore.setBetMoney((reset ? 0 : targetBetMoney) + plusNumber, betMoneyType)
    }
  }

  if (targetBetMoney > 0 && betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) {
    // 더 이상 사용하지 않는 다이얼로그
    globalStore.pushDialogYesNo({
      title: '알림',
      text: ['G머니를 입력하는 경우', '입력한 베팅권이 초기화 됩니다.', 'G머니로 베팅하시겠습니까?'],
      wrapClassName: 'reset-amount',
      className: 'small-size',
      positivePress: '확인',
      negativePress: '취소',
      callbackPositive: () => {
        addBetMoney(true)
      },
    })
  } else {
    addBetMoney()
  }
}

export function onClickCouponAllin(targetCart: CartItem[], ticket: number, maxBetMoney: number): void {
  if (isInputNotAvailable(targetCart)) {
    return
  }

  const betMoneyType = getBetMoneyTypeFromSelectedBetSlipTab()
  if (isExceedMaxBetMoney((ticket) * 0.1, maxBetMoney)) {
    if (matchupStore.betMoney * 0.1 >= maxBetMoney) {
      const maxBetAlertText = makeMaxBetAlertText(betMoneyType, maxBetMoney)
      globalStore.showBubblePopupTimer(BubbleTextType.MAX_BET_ALERT, maxBetAlertText, BubbleType.BET_SLIP)
    }
    matchupStore.setBetMoney(maxTicketBetMoney(), betMoneyType)
    return
  }

  const ticketCount = getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, ticket)
  matchupStore.setBetMoney(
    getTicketFromTicketCount(BET_TICKET_TYPE.BET_TICKET1, ticketCount), PROPERTY_ID.NEW_BET_TICKET_G
  )
}

export function getBetMoneyTypeFromSelectedBetSlipTab(): PROPERTY_ID {
  const tabKey = matchupStore.selectedBetSlipTabIndexKey
  return getPropertyIdByBetSlipIndexKey(tabKey)
}

export function onClickMoneyAllin(targetCart: CartItem[], money: number, maxBetMoney: number): void {
  if (isInputNotAvailable(targetCart)) {
    return
  }

  const betMoneyType = getBetMoneyTypeFromSelectedBetSlipTab()
  if (isExceedMaxBetMoney(money, maxBetMoney)) {
    if (matchupStore.betMoney >= maxBetMoney) {
      const maxBetAlertText = makeMaxBetAlertText(betMoneyType, maxBetMoney)
      globalStore.showBubblePopupTimer(BubbleTextType.MAX_BET_ALERT, maxBetAlertText, BubbleType.BET_SLIP)
    }
    matchupStore.setBetMoney(maxBetMoney, betMoneyType)
    return
  }

  matchupStore.setBetMoney(money, betMoneyType)
}

export function onClickMoneyReset(): void {
  const propertyId = getBetMoneyTypeFromSelectedBetSlipTab()
  matchupStore.setBetMoney(0, propertyId)
}

export function onShowBetCoupon(ticket: number, targetBetMoney: number, betMoneyType: PROPERTY_ID): void {
  if (isBetTicketInputNotAvailable(ticket)) {
    // 더 이상 사용하지 않는 다이얼로그
    globalStore.pushDialogOk({ title: '알림', text: ['보유한 베팅권이 없습니다.'], className: 'small-size' })
    return
  }

  if (targetBetMoney > 0 && (betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.DIA)) {
    // 더 이상 사용하지 않는 다이얼로그
    globalStore.pushDialogYesNo({
      title: '알림',
      text: ['베팅권을 사용하는 경우', `입력한 ${getTextByPropertyId(betMoneyType)}가 초기화됩니다.`, '베팅권을 사용하시겠습니까?'],
      wrapClassName: 'reset-amount',
      className: 'small-size',
      negativePress: '취소',
      positivePress: '확인',
      callbackPositive: () => {
        matchupStore.setBetMoney(0, PROPERTY_ID.MONEY)
        globalStore.setVisibleBetCoupon(true)
      },
    })
  } else {
    globalStore.setVisibleBetCoupon(true)
  }
}

export function makeBetMoneyRangeText(): string {
  const isClubLimitBetOn = globalStore.getClubLimBetOnOff()
  const { club, currentGameKey } = matchupStore
  const {
    pre_betmoney_min,
    live_betmoney_min,
    pre_betmoney_max,
    live_betmoney_max,
  } = club || {}

  let betMoneyRangeText = ''
  if (isClubLimitBetOn) {
    const clubGmoneyMaxBetLimit = globalStore.getClubGmoneyMaxBetLimit()
    betMoneyRangeText = `${formatNumber(pre_betmoney_min)} ~ ${formatNumber(clubGmoneyMaxBetLimit)}`
    if (currentGameKey === GAME_TYPE.LIVE) {
      betMoneyRangeText = `${formatNumber(live_betmoney_min)} ~ ${formatNumber(clubGmoneyMaxBetLimit)}`
    }
  } else {
    betMoneyRangeText = pre_betmoney_max > 0 ? `${formatNumber(pre_betmoney_min)} ~ ${formatNumber(pre_betmoney_max)}` : '제한없음'

    if (currentGameKey === GAME_TYPE.LIVE) {
      betMoneyRangeText = live_betmoney_max > 0 ? `${formatNumber(live_betmoney_min)} ~ ${formatNumber(live_betmoney_max)}` : '제한없음'
    } else if (currentGameKey === GAME_TYPE.SPECIAL) {
      betMoneyRangeText = pre_betmoney_max > 0 ? `${formatNumber(pre_betmoney_min)} ~ ${formatNumber(getClubSpcialBetMaxMoney(club))}` : '제한없음'
    }
  }
  return betMoneyRangeText
}

export function getPenaltyAppliedRate(cart: CartItem[], extraOddsRate: number): number {
  let rate = getRate(cart, null)    // 싱글 베팅 패널티를 계산한 후 추가 배당을 계산해야 한다.
  if (cart.length === 1) {
    rate = getSingleBetPenaltyRate(rate, authStore.userInfo?.id)
  }

  if (!_.isEmpty(_.trim(_.toString(extraOddsRate)))) {
    rate += _.toNumber(extraOddsRate)
  }

  return rate
}

export function getRate(cart: CartItem[], extraOddsRate: number): number {
  let rate = 0
  for (const el of cart) {
    if (!el) {
      continue
    }
    if (rate === 0) {
      rate = 1
    }
    rate *= Number(el.rate)
  }

  if (!_.isEmpty(_.trim(_.toString(extraOddsRate)))) {
    rate += _.toNumber(extraOddsRate)
  }
  return MatchUtils.rateFloorCalculate(rate)
}

export function getHitMoney(betMoney: number, rate: number) {
  return MatchUtils.rateFloorCalculateWithExtraValue(rate, betMoney)
}

export function exchangeMoneyByBetMoneyType(money: number, betMoneyType: number): number {
  let exchangedMoney = Math.floor(money)
  switch (betMoneyType) {
    case PROPERTY_ID.MONEY:
    case PROPERTY_ID.DIA:
      break
    case PROPERTY_ID.NEW_BET_TICKET_G:
      exchangedMoney = getRatioTicketMoney(exchangedMoney)
      break
  }
  return exchangedMoney
}

export function maxBetMoneyByBetMoneyType(id: PROPERTY_ID, typeOn: BET_TYPE_ON) {
  const clubOption = matchupStore.clubOption

  let maxBetMoney

  switch (id) {
    case PROPERTY_ID.MONEY:
    case PROPERTY_ID.NEW_BET_TICKET_G:
      maxBetMoney = globalStore.getClubGmoneyMaxBetLimit()
      break
    case PROPERTY_ID.DIA:
      maxBetMoney = typeOn === BET_TYPE_ON.UNIFIED_LIVE ? clubOption?.live_betmoney_max : clubOption?.pre_betmoney_max
      break
  }

  return maxBetMoney
}
